export const TRANSLATIONS_ES_ONBOARDING = {
  "homePublic.hero.eyebrow": "Vista en vivo",
  "homePublic.hero.title": "Tu espacio listo para cuentas, antes de conectar nada",
  "homePublic.hero.subtitle":
    "Explora un entorno simulado con métricas anonimizadas para ver cómo Innovadoc IA mantiene alineados a los equipos antes de salir a producción.",
  "homePublic.hero.ctaPrimary": "Crear mi cuenta",
  "homePublic.hero.ctaSecondary": "Entrar a mi workspace",
  "homePublic.hero.metrics.documents": "Documentos indexados",
  "homePublic.hero.metrics.latency": "Tiempo de respuesta medio",
  "homePublic.hero.metrics.compliance": "Cobertura de conocimiento",
  "homePublic.mock.eyebrow": "Telemetría simulada",
  "homePublic.mock.title": "Señales generadas con datos seguros",
  "homePublic.mock.subtitle":
    "Estos números se actualizan automáticamente para mostrar cómo se siente la plataforma con tráfico real.",
  "homePublic.mock.cards.documents.label": "Documentos esta semana",
  "homePublic.mock.cards.documents.detail": "Cargas únicas sincronizadas en los últimos 7 días",
  "homePublic.mock.cards.repositories.label": "Fuentes conectadas",
  "homePublic.mock.cards.repositories.detail": "Drive, SharePoint, S3, Gmail y más",
  "homePublic.mock.cards.users.label": "Asientos activos",
  "homePublic.mock.cards.users.detail": "Miembros que usan chat y automatizaciones",
  "homePublic.mock.cards.alerts.label": "Alertas de atención",
  "homePublic.mock.cards.alerts.detail": "Pendientes de remediación para administradores",
  "homePublic.features.eyebrow": "Lo que recibes",
  "homePublic.features.title": "Listo para empresa desde el día cero",
  "homePublic.features.subtitle": "Todo lo necesario para probar la experiencia sin tocar datos productivos.",
  "homePublic.features.ingestion.title": "Ingesta sin fricción",
  "homePublic.features.ingestion.desc": "Arrastra carpetas, reenvía correos o conecta repositorios en minutos.",
  "homePublic.features.security.title": "Seguridad primero",
  "homePublic.features.security.desc": "Controles alineados a SOC 2, permisos granulares y aislamiento por workspace.",
  "homePublic.features.operations.title": "Operaciones conscientes",
  "homePublic.features.operations.desc": "Dashboards en vivo, alertas de salud y colas de tareas para humanos en el loop.",
  "homePublic.plan.eyebrow": "Desglose del plan",
  "homePublic.plan.title": "Plan Starter con salvaguardas reales",
  "homePublic.plan.subtitle": "Pensado para líderes de innovación que validan experiencias RAG con stakeholders internos.",
  "homePublic.plan.points.speed.title": "Pilotos más rápidos",
  "homePublic.plan.points.speed.desc": "Provisiona almacenes vectoriales dedicados y flujos de chat listos para usar.",
  "homePublic.plan.points.context.title": "Contexto confiable",
  "homePublic.plan.points.context.desc": "Detecta PII, clasifica repositorios y conserva trazabilidad en cada chunk.",
  "homePublic.plan.points.support.title": "Despliegue guiado",
  "homePublic.plan.points.support.desc": "Equipo de Customer Success más office hours asíncronas para mantener el ritmo.",
  "homePublic.plan.card.title": "Qué incluye",
  "homePublic.plan.card.subtitle": "10 usuarios · 2 workspaces · 50K créditos de prompts · telemetría premium.",
  "homePublic.plan.card.ctaPrimary": "Iniciar piloto gratis",
  "homePublic.plan.card.ctaSecondary": "Ver opciones enterprise",
  "homePublic.testimonial.quote": "El entorno simulado ayudó a que nuestro equipo de compliance aprobara el despliegue en una sola semana.",
  "homePublic.testimonial.author": "Lucía Hernández",
  "homePublic.testimonial.role": "Líder de Transformación IA, Vectoris",
  "homePublic.cta.title": "¿Listo para ver tus documentos en acción?",
  "homePublic.cta.subtitle": "Activa Innovadoc IA con datos ficticios hoy y conecta tus repositorios cuando legal lo autorice.",
  "homePublic.cta.primary": "Lanzar workspace",
  "homePublic.cta.secondary": "Hablar con un experto",
  "wizard.welcome_title": "¡Bienvenido al asistente!",
  "wizard.welcome_image_alt": "Ilustración de bienvenida",
  "wizard.welcome_description":
    "Configura tu perfil y preferencias para comenzar a usar el sistema.",
  "wizard.profile_title": "Información de Perfil",
  "wizard.profile_description": "Cuéntanos sobre ti y tu organización.",
  "wizard.preferences_title": "Preferencias",
  "wizard.preferences_description":
    "Personaliza tu experiencia seleccionando tema, idioma y otras opciones.",
  "wizard.complete_title": "¡Listo!",
  "wizard.complete_description": "Tu perfil ha sido configurado correctamente.",
  "wizard.feature_chat_title": "Chat Inteligente",
  "wizard.feature_chat_desc":
    "Haz preguntas y obtén respuestas precisas basadas en tus documentos.",
  "wizard.feature_docs_title": "Gestión de Documentos",
  "wizard.feature_docs_desc":
    "Sube, organiza y consulta tus documentos fácilmente.",
  "wizard.feature_insights_title": "Análisis e Insights",
  "wizard.feature_insights_desc":
    "Obtén análisis y estadísticas relevantes de tus datos.",
  "wizard.first_name": "Nombres",
  "wizard.first_name_required": "Los nombres son obligatorios.",
  "wizard.lastname": "Apellidos",
  "wizard.lastname_required": "Los apellidos son obligatorios.",
  "wizard.name_required": "El nombre es obligatorio.",
  "wizard.country": "País",
  "wizard.country_required": "El país es obligatorio.",
  "wizard.job_title": "Puesto",
  "wizard.job_required": "El puesto es obligatorio.",
  "wizard.company": "Compañía",
  "wizard.company_required": "La compañía es obligatoria.",
  "wizard.timezone": "Zona horaria",
  "wizard.timezone_select": "Selecciona tu zona horaria",
  "wizard.timezone_required": "La zona horaria es obligatoria.",
  "wizard.timezone_search": "Buscar ciudad o zona...",
  "wizard.timezone_no_results": "Sin resultados",
  "wizard.org_type": "Tipo de organización",
  "wizard.org_enterprise": "Empresa",
  "wizard.org_education": "Educación",
  "wizard.org_government": "Gobierno",
  "wizard.org_nonprofit": "ONG",
  "wizard.org_other": "Otro",
  "wizard.org_size": "Tamaño de la organización",
  "wizard.size_small": "Pequeña (1-50)",
  "wizard.size_medium": "Mediana (51-250)",
  "wizard.size_large": "Grande (251-1000)",
  "wizard.size_enterprise": "Corporativo (1000+)",
  "wizard.theme_preference": "Preferencia de tema",
  "wizard.language_preference": "Preferencia de idioma",
  "wizard.yes": "Sí",
  "wizard.no": "No",
  "wizard.other_preferences": "Otras preferencias",
  "wizard.enable_notifications": "Habilitar notificaciones",
  "wizard.allow_data_collection": "Permitir recopilación de datos anónimos",
  "wizard.data_collection_info":
    "Tus datos ayudan a mejorar el sistema. No se recopila información personal.",
  "wizard.summary_title": "Resumen de configuración",
  "wizard.previous": "Anterior",
  "wizard.next": "Siguiente",
  "wizard.complete": "Completar",
  "wizard.save_error": "Error al guardar la configuración. Intenta de nuevo.",
  "wizard.copy_support_reference": "Copiar código",
  "wizard.support_reference_copied": "Copiado",
  "wizard.second_name": "Apellido",
  "wizard.second_name_required": "El apellido es obligatorio.",
  filtered_results: "resultados filtrados",
  "invite.validating": "Validando invitación...",
  "invite.invalid_or_expired": "Invitación inválida o expirada",
  "invite.invalid_or_expired_desc": "El enlace de invitación ya no es válido. Solicita una nueva invitación al administrador.",
  "invite.missing_params": "Invitación incompleta",
  "invite.missing_params_desc": "El enlace de invitación no contiene la información necesaria para continuar.",
  "invite.not_found": "Invitación no encontrada",
  "invite.not_found_desc": "No encontramos una invitación activa para este correo.",
  "invite.server_error": "No pudimos validar la invitación",
  "invite.server_error_desc": "Ocurrió un error al validar la invitación. Intenta nuevamente más tarde.",
  "invite.bad_request": "La información enviada no es válida.",
  "invite.back_to_login": "Volver al login",
  "invite.email": "Correo invitado",
  "invite.company": "Empresa",
  "invite.role": "Rol",
  "invite.company_from_invite": "La empresa viene definida por la invitación.",
  "invite.password_step": "Crea tu contraseña",
  "invite.password_step_desc": "Define una contraseña segura para completar tu acceso.",
  "invite.password": "Contraseña",
  "invite.password_placeholder": "Ingresa tu contraseña",
  "invite.password_required": "La contraseña es obligatoria.",
  "invite.password_min_length": "La contraseña debe tener al menos 8 caracteres.",
  "invite.password_hint": "Usa al menos 8 caracteres.",
  "invite.confirm_password": "Confirmar contraseña",
  "invite.confirm_password_placeholder": "Repite tu contraseña",
  "invite.passwords_not_match": "Las contraseñas no coinciden.",
};
